  import React, { useState, useEffect } from "react";
  import { Navbar, Nav, Container, Button, Offcanvas } from "react-bootstrap";
  import "bootstrap/dist/css/bootstrap.min.css";
  import { Link, useLocation, useNavigate } from "react-router-dom";
  import SmoothScroll from "smooth-scroll";

  // Initialize smooth scroll
  const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
  });

  export const Navigation = () => {
    const [show, setShow] = useState(false);
    const [activeLink, setActiveLink] = useState("home");
    const location = useLocation();
    const navigate = useNavigate();

    const navItems = [
      { key: "home", label: "Home", target: "/" },
      { key: "about", label: "About", target: "/about" },
      { key: "Projects", label: "Our Projects", target: "/projects" },
    ];

    // Handle handle-bar opacity on scroll (mobile bottom sheet)
    useEffect(() => {
      const handleScroll = () => {
        const handleBar = document.getElementById("handle-bar");
        if (handleBar && show) {
          handleBar.style.opacity = window.scrollY > 10 ? "0" : "1";
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, [show]);

    // Sync activeLink with route changes
    useEffect(() => {
      if (location.pathname === "/about") {
        setActiveLink("about");
      } else if (location.pathname === "/") {
        // If we're on home, keep "Projects" active if it was already selected;
        // otherwise default to "home"
        setActiveLink((prev) => (prev === "Projects" ? "Projects" : "home"));
      }
    }, [location.pathname]);

  const handleNavClick = (key, target) => {
    // Cancel any ongoing smooth scroll
    if (scroll) scroll.cancelScroll();
    
    setActiveLink(key);
    setShow(false);

    // If it's a route change (like "/" or "/about" or "/projects")
    if (target.startsWith("/")) {
      // Force scroll to top BEFORE navigating
      window.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
      document.body.scrollTo(0, 0);
      
      navigate(target);
      
      // Also scroll after navigation as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTo(0, 0);
        document.body.scrollTo(0, 0);
      }, 0);
      
      return;
    }

    // Otherwise it's an in-page anchor like "#projects"
    if (location.pathname === "/") {
      const el = document.querySelector(target);
      if (el) scroll.animateScroll(el);
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.querySelector(target);
        if (el) scroll.animateScroll(el);
      }, 100);
    }
  };

    return (
      <>
        {/* ======= DESKTOP NAVBAR ======= */}
        <Navbar
          expand="lg"
          className="d-flex align-items-center justify-content-between"
          style={{
            zIndex: "1050",
            minHeight: "65px",
            transition: "all 0.3s ease",
            position: "fixed",
            width: "100%",
            top: "0", // Stays to the top
            backgroundColor: "#ffffff", // Added white background
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Optional: Add a subtle shadow to ensure it stands out
          }}
        >
          <Container
            fluid
            className="d-flex align-items-center justify-content-between"
            style={{ maxWidth: "1300px" }}
          >
            {/* === LEFT: LOGO === */}
            <Navbar.Brand
              as={Link}
              to="/"
              className="d-flex align-items-center me-auto"
            >
              <img
                src="/img/logo.png"
                alt="Logo"
                style={{ height: "45px", marginRight: "10px" }}
              />
              <span style={{ fontWeight: 700, fontSize: "1.7rem", color: "#262626", letterSpacing: "1px" }}>
                WEB SARI SARI
              </span>
            </Navbar.Brand>

            {/* === CENTER: NAV LINKS (Desktop) === */}
            <Nav
              className="mx-auto d-none d-lg-flex align-items-center"
              style={{
                background:
                  "linear-gradient(120deg, rgba(21, 207, 192, 0.11), rgba(5, 78, 72, 0.25))",
                backdropFilter: "blur(25px) saturate(180%)",
                WebkitBackdropFilter: "blur(25px) saturate(180%)",
                borderRadius: "50px",
                padding: "0.9rem 2.5rem",
                gap: "3rem",
                border: "1px solid rgba(255,255,255,0.35)",
                transition: "all 0.4s ease",
              }}
            >
              {navItems.map((item) => (
                <Nav.Link
                  key={item.key}
                  as="span"
                  onClick={() => handleNavClick(item.key, item.target)}
                  style={{
                    color:
                      activeLink === item.key ? "#000" : "rgba(0, 0, 0, 0.7)",
                    fontWeight: activeLink === item.key ? "700" : "500",
                    fontSize: "1.5rem",
                    transition: "all 0.25s ease-in-out",
                    padding: "0.4rem 1rem",
                    borderRadius: "12px",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.4)")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.background = "transparent")
                  }
                >
                  {item.label}
                </Nav.Link>
              ))}
            </Nav>

            {/* === RIGHT: GET STARTED (Desktop) === */}
            <div className="d-none d-lg-block ms-auto">
              <Button
                as={Link}
                to="/get-started"
                style={{
                  background:
                    "linear-gradient(120deg, rgba(21, 207, 192, 0.11), rgba(5, 78, 72, 0.25))",
                  color: "#000",
                  borderRadius: "999px",
                  fontWeight: "600",
                  fontSize: "1.5rem",
                  padding: "1rem 2.6rem",
                  border: "1px solid rgba(255,255,255,0.4)",
                  backdropFilter: "blur(15px)",
                  WebkitBackdropFilter: "blur(15px)",
                }}
              >
                Get Started
              </Button>
            </div>

            {/* === MOBILE BURGER === */}
            <div
              className="d-lg-none"
              onClick={() => setShow((prev) => !prev)}
              style={{
                cursor: "pointer",
                padding: "0.75rem",
                marginLeft: "auto",
              }}
            >
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: "28px",
                    height: "3px",
                    background: "#000",
                    marginBottom: i < 2 ? "6px" : "0",
                    borderRadius: "2px",
                  }}
                ></div>
              ))}
            </div>
          </Container>
        </Navbar>

        {/* ======= MOBILE OFFCANVAS MENU ======= */}
        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          placement="bottom"
          style={{
            height: "55vh",
            maxHeight: "480px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(25px) saturate(180%)",
            WebkitBackdropFilter: "blur(25px) saturate(180%)",
            color: "#fff",
            borderTopLeftRadius: "24px",
            borderTopRightRadius: "24px",
            textAlign: "center",
            overflowY: "auto",
            borderTop: "1px solid rgba(255,255,255,0.3)",
          }}
          scroll={true}
          backdrop={true}
        >
          <Offcanvas.Body
            className="d-flex flex-column align-items-center justify-content-start"
            style={{
              paddingTop: "1rem",
              gap: "1.8rem",
              position: "relative",
            }}
          >
            {/* Handle bar */}
            <div
              id="handle-bar"
              style={{
                width: "60px",
                height: "6px",
                backgroundColor: "rgba(255,255,255,0.9)",
                borderRadius: "10px",
                marginBottom: "0.75rem",
              }}
            ></div>

            {/* Logo */}
            <Navbar.Brand as={Link} to="/" className="mb-3">
              <img src="/img/nav head.png" alt="Logo" style={{ height: "55px" }} />
            </Navbar.Brand>

            {/* Mobile Links */}
            <Nav
              className="flex-column w-100 text-center"
              style={{
                gap: "1.2rem",
                padding: "0 1rem",
                width: "90%",
                margin: "0 auto",
              }}
            >
              {navItems.map((item) => (
                <Nav.Link
                  key={item.key}
                  as="span"
                  onClick={() => handleNavClick(item.key, item.target)}
                  style={{
                    color:
                      activeLink === item.key ? "#fff" : "rgba(255,255,255,0.8)",
                    fontWeight: activeLink === item.key ? "700" : "500",
                    fontSize: "1.5rem",
                    border: "1px solid rgba(255,255,255,0.25)",
                    borderRadius: "14px",
                    padding: "0.9rem 1rem",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    background: "rgba(255,255,255,0.1)",
                    boxShadow:
                      "inset 0 1px 1px rgba(255,255,255,0.4), 0 2px 10px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease-in-out",
                    cursor: "pointer",
                  }}
                >
                  {item.label}
                </Nav.Link>
              ))}
            </Nav>

            {/* Mobile Get Started */}
            <Button
              as={Link}
              to="/get-started"
              onClick={() => setShow(false)}
              style={{
                background:
                  "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(230,230,230,0.7))",
                color: "#000",
                borderRadius: "14px",
                fontWeight: "700",
                fontSize: "1.4rem",
                padding: "1rem 2.8rem",
                width: "90%",
                marginTop: "2rem",
                border: "1px solid rgba(255,255,255,0.5)",
              }}
            >
              Get Started
            </Button>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  };